/**
* SwiperSlider
* @description Web component used to create sliders, configurable with data-options attribute.
*/

(async () => {
  
  if (!customElements.get('swiper-slider')) {
    
    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");
    
    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);
    
    class SwiperSlider extends HTMLElement {
      constructor() {
        super();
        
        this.swiper = this;
        this.swiperOptions = {};
        
        if(!this.swiper) {
          return;
        }
        
        // Check if we have extra options on the HTML
        if (this.swiper?.dataset?.options) {
          const options = JSON.parse(this.swiper.dataset.options);
          if (options) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...options
            }
          }
        }
        
        /**
        * Listen to extra events when in Shopify editor
        */
        if (Shopify.designMode) {
          // Update the swiper when the section event is triggerd
          window.addEventListener('shopify:section:load', (event) => {
            this.swiper.update();
          });
          // When on block select go to the slide in front-end
          window.addEventListener('shopify:block:select', (event) => {
            this.handleSectionEvents(event);
          });
        }
        
        this.swiper = new Swiper(this.swiper, this.swiperOptions);
        
      }
      
      /**
      * Handles the theme editor block change/edit event
      * @param {Object} event
      */
      handleSectionEvents(event) {
        // Slide to slide based on the data attribute from the target and add 1 to get the slide index
        this.swiper.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
      }
      
    }
    
    window.SwiperSlider = SwiperSlider;
    
    customElements.define('swiper-slider', SwiperSlider);
    
  }
  
})();